<template>
  <div class="reassign-modal-card modal-card">
    <section class="modal-card-body">
      <h2><strong>Select MCS Code to Reassign a Submission</strong></h2>
      <table width="100%">
        <tr>
          <td width="20%">
            <span class="column"
              ><b-field label="MCS Code" :class="classes"></b-field
            ></span>
            <b-select
              expanded
              :disabled="false"
              v-model="mcs"
              @input="onSelect(mcs)"
            >
              <option v-for="mcs in mcsList" :value="mcs" :key="mcs.id">
                {{ mcs }}
              </option>
            </b-select>
          </td>
          <td width="40%">
            <span class="column"
              ><b-field label="Product Manager" :class="classes"></b-field
            ></span>
            <span class="column"
              ><b-field label="" :class="classes">{{
                pmpsData.prodMngr
              }}</b-field></span
            >
          </td>
          <td width="40%">
            <span class="column"
              ><b-field label="Product Specialist" :class="classes"></b-field
            ></span>
            <span class="column">
              <b-field label="" :class="classes">{{
                pmpsData.prodSpclst
              }}</b-field></span
            >
          </td>
        </tr>
      </table>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="saveMcsCode()">
        Continue
      </button>
      <button class="button" type="button" @click="$parent.close()">
        Close
      </button>
    </footer>
  </div>
</template>

<script>
export default {
  name: "ReassignSubmission",
  props: ["mcsList", "submissionIdForReaasign"],
  data() {
    return {
      prodMngr: "",
      prodSplct: "",
      selectedValue: "",
      classes: "",
      mcs: "",
      pmpsData: {
        prodMngr: "",
        prodSpclst: ""
      }
    };
  },
  methods: {
    onSelect(value) {
      this.selectedValue = value;
      var reassignFormScope = this;
      var args = {};
      args.headers = {
        "content-type": "application/json"
      };
      this.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}reassign/getPMPSName/${value}`,
          null,
          args
        )
        .then(response => {
          console.log(response.data);
          reassignFormScope.pmpsData.prodMngr = response.data["prodMngr"];
          reassignFormScope.pmpsData.prodSpclst = response.data["prodSpclst"];
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          this.$buefy.dialog.alert({
            message: `Failed to load MCS Code - ${value}. Please check for invalid data and/or clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    saveMcsCode() {
      var reassignFormScope = this;
      var userData = "";
      var status = "RE";
      if (this.selectedValue === "") {
        reassignFormScope.$buefy.dialog.alert({
          message: `MCS Code is required.`,
          confirmText: "OK",
          type: "is-danger"
        });
      } else {
        if (sessionStorage.getItem("se_ni_user")) {
          userData = JSON.parse(sessionStorage.getItem("se_ni_user"));
        } else {
          userData = window.$cookies.get("ni_key");
        }
        this.$http
          .post(
            `${process.env.VUE_APP_API_BASE_DOMAIN}submitCancelWorkflow?nbrNewItemCrKey=${this.submissionIdForReaasign}&nameUser=${userData.networkId}&status=${status}&mcsCode=${this.selectedValue}`
          )
          // eslint-disable-next-line no-unused-vars
          .then(function(response) {
            reassignFormScope.$buefy.dialog.alert({
              message: `Reassignment of Submission ID - ${reassignFormScope.submissionIdForReaasign} is Successful.`,
              confirmText: "OK",
              type: "is-success",
              onConfirm: () => reassignFormScope.$emit("goToHomePage", true)
            });
          });
      }
    }
  }
};
</script>

<style scoped></style>
